import language from "@dealZY/config/language.config";

import englishLang from "@dealZY/assets/images/flag/uk.svg";
import frenchLang from "@dealZY/assets/images/flag/france.svg";

const config = {
  defaultLanguage: language,
  options: [
    {
      languageId: "french",
      locale: "fr",
      text: "French",
      icon: frenchLang,
    },
    {
      languageId: "english",
      locale: "en",
      text: "English",
      icon: englishLang,
    },
  ],
};

export function getCurrentLanguage(lang) {
  let selecetedLanguage = config.options[0];
  config.options.forEach((language) => {
    if (language.languageId === lang) {
      selecetedLanguage = language;
    }
  });
  return selecetedLanguage;
}
export default config;
